var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._b(
      { staticClass: "tab-item", class: { "tab-item-active": _vm.active } },
      "div",
      _vm.$attrs,
      false
    ),
    [
      _c(
        "div",
        [
          _c("div", [_vm._v(" " + _vm._s(_vm.text) + " ")]),
          !_vm.item.component || !_vm.item.component.label
            ? _c("div", { staticClass: "tab-item-no-content" }, [
                _c("p", [
                  _vm._v(" " + _vm._s(_vm.value || _vm.default_value) + " "),
                ]),
              ])
            : _c(
                _vm.item.component.label,
                _vm._b(
                  {
                    tag: "component",
                    attrs: {
                      tab: _vm.item,
                      value: _vm.value,
                      default_value: _vm.default_value,
                    },
                  },
                  "component",
                  _setup.attrs,
                  false
                )
              ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }